"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoCaptionName = exports.getVideoTitle = exports.getVideoPosterFileName = exports.getVideoFileName = exports.assertVideoId = exports.VIDEO_IDS = void 0;
const Get_1 = __importDefault(require("../utils/Get"));
var VideoId;
(function (VideoId) {
    VideoId["WELCOME"] = "WELCOME";
    VideoId["COPING_WITH_STRESS_LET_THOUGHTS_GO_VIDEO"] = "COPING_WITH_STRESS_LET_THOUGHTS_GO_VIDEO";
    VideoId["COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO"] = "COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO";
    VideoId["COPING_WITH_STRESS_BREATHING_EXAMPLE"] = "COPING_WITH_STRESS_BREATHING_EXAMPLE";
    VideoId["MOOD_SPIRAL"] = "MOOD_SPIRAL";
    VideoId["COPING_WITHOUT_ALCOHOL_AND_DRUGS_OUTRO_VIDEO"] = "COPING_WITHOUT_ALCOHOL_AND_DRUGS_OUTRO_VIDEO";
    VideoId["EFFECTIVE_COMMUNICATION_VIDEO"] = "EFFECTIVE_COMMUNICATION_VIDEO";
    VideoId["ENCOURAGEMENT_AND_PRAISE_NOTICING_VIDEO"] = "ENCOURAGEMENT_AND_PRAISE_NOTICING_VIDEO";
    VideoId["PROACTIVE_PARENTING_BEDTIME_ROUTINE_VIDEO"] = "PROACTIVE_PARENTING_BEDTIME_ROUTINE_VIDEO";
    VideoId["PROACTIVE_PARENTING_PLAY_VIDEO"] = "PROACTIVE_PARENTING_PLAY_VIDEO";
    VideoId["RULES_AND_CONSEQUENCES_IGNORING_VIDEO"] = "RULES_AND_CONSEQUENCES_IGNORING_VIDEO";
    VideoId["POSITIVE_PARENTING_GIVING_DIRECTIONS_VIDEO"] = "POSITIVE_PARENTING_GIVING_DIRECTIONS_VIDEO";
    VideoId["POSITIVE_PARENTING_NOTICE_BEHAVIOR_VIDEO"] = "POSITIVE_PARENTING_NOTICE_BEHAVIOR_VIDEO";
})(VideoId || (VideoId = {}));
const videos = {
    [VideoId.WELCOME]: {
        title: "How to use Family Check-up",
        fileName: "Ani_00",
        posterFileName: "/video-icons/Ani_00.png",
    },
    [VideoId.COPING_WITH_STRESS_LET_THOUGHTS_GO_VIDEO]: {
        title: "Let thoughts go",
        fileName: "Leaf_Stream_Mood_v2",
        posterFileName: "/video-icons/Leaf_Stream_Mood_v2.png",
    },
    [VideoId.COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO]: {
        title: "Breathing Exercise",
        fileName: "Ani_02",
        posterFileName: "/video-icons/Ani_02.png",
    },
    [VideoId.COPING_WITH_STRESS_BREATHING_EXAMPLE]: {
        title: "Coping with stress",
        fileName: "Ani_01",
        posterFileName: "/video-icons/Ani_01.png",
    },
    [VideoId.COPING_WITHOUT_ALCOHOL_AND_DRUGS_OUTRO_VIDEO]: {
        title: "Breathing Exercise",
        fileName: "Ani_02",
        posterFileName: "/video-icons/Ani_02.png",
    },
    [VideoId.EFFECTIVE_COMMUNICATION_VIDEO]: {
        title: "Effective communication",
        fileName: "Ani_06",
        posterFileName: "/video-icons/Ani_06.png",
    },
    [VideoId.ENCOURAGEMENT_AND_PRAISE_NOTICING_VIDEO]: {
        title: "Encouragement & Praise",
        fileName: "Ani_04",
        posterFileName: "/video-icons/Ani_04.png",
    },
    [VideoId.PROACTIVE_PARENTING_BEDTIME_ROUTINE_VIDEO]: {
        title: "Bedtime routine",
        fileName: "Ani_07",
        posterFileName: "/video-icons/Ani_07.png",
    },
    [VideoId.PROACTIVE_PARENTING_PLAY_VIDEO]: {
        title: "Play",
        fileName: "Ani_08",
        posterFileName: "/video-icons/Ani_08.png",
    },
    [VideoId.RULES_AND_CONSEQUENCES_IGNORING_VIDEO]: {
        title: "Ignoring",
        fileName: "Ani_09",
        posterFileName: "/video-icons/Ani_09.png",
    },
    [VideoId.POSITIVE_PARENTING_GIVING_DIRECTIONS_VIDEO]: {
        title: "Give directions",
        fileName: "Ani_05",
        posterFileName: "/video-icons/Ani_05.png",
    },
    [VideoId.POSITIVE_PARENTING_NOTICE_BEHAVIOR_VIDEO]: {
        title: "Notice positive behavior",
        fileName: "Ani_03",
        posterFileName: "/video-icons/Ani_03.png",
    },
    [VideoId.MOOD_SPIRAL]: {
        title: "Mood Spiral",
        fileName: "Spiral2020",
        posterFileName: "/video-icons/Spiral2020.png",
    },
};
exports.default = VideoId;
exports.VIDEO_IDS = Object.values(VideoId);
function assertVideoId(value, param) {
    const asString = Get_1.default.string(value, param);
    const videoId = exports.VIDEO_IDS.find((id) => id === asString);
    if (!videoId) {
        throw Object.assign(new Error(`Invalid video Id: "${value}"`), {
            status: 400,
        });
    }
    return videoId;
}
exports.assertVideoId = assertVideoId;
/**
 * Takes a video id and returns the video's file name as it's stored in S3/Minio.
 */
function getVideoFileName(videoId, extension) {
    return `${videos[videoId].fileName}${extension[0] === "." ? "" : "."}${extension}`;
}
exports.getVideoFileName = getVideoFileName;
function getVideoPosterFileName(videoId) {
    const video = videos[videoId];
    return video === null || video === void 0 ? void 0 : video.posterFileName;
}
exports.getVideoPosterFileName = getVideoPosterFileName;
/**
 * Takes a video id and returns the video's title.
 */
function getVideoTitle(videoId) {
    return videos[videoId].title;
}
exports.getVideoTitle = getVideoTitle;
function getVideoCaptionName(videoId) {
    return `${videos[videoId].fileName}.vtt`;
}
exports.getVideoCaptionName = getVideoCaptionName;
//# sourceMappingURL=data:application/json;base64,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